import { message } from './messageCode';

interface TipsProps {
  containerId: string;
  contentId: string;
  text: string;
  top?: number;
  left?: number;
}

interface PhoneCodeProps {
  appkey: string;
  /** 挂载到的dom id 名字 */
  elementId?: string;
  /** 支持指定环境, 默认当前域名 */
  host?: string;
  /** 是否渲染dom */
  renderDom?: boolean;
  /** 登录成功回调事件 */
  onCallback?: (res: any) => void;
  /** 失败回调事件 */
  onError?: (err: any) => void;
}

export class VerifyCode {
  version = '1.0.0';
  time = 60;
  props: PhoneCodeProps;
  host: string;
  appkey = '';
  renderDom = false;
  phoneInputEle: HTMLInputElement | undefined;
  codeInputEle: HTMLInputElement | undefined;

  constructor(props: PhoneCodeProps) {
    this.host = props.host ?? '';
    this.appkey = props.appkey;
    this.renderDom = props.renderDom ?? false;
    this.props = props;
    this.initialize();
  }

  protected async initialize() {
    if (!this.renderDom) return;
    const element = document.getElementById(this.props.elementId as string);
    const rootDom = this.createRoot();
    element?.appendChild(rootDom);
  }

  protected createHttpRequest(url, method, data): Promise<any> {
    return new Promise((resolve, reject) => {
      const ajax = new XMLHttpRequest();
      ajax.open(method, url);
      ajax.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded',
      );
      ajax.send(data);
      ajax.onreadystatechange = () => {
        if (ajax.readyState === 4) {
          if (ajax.status === 200) {
            const jsonData = JSON.parse(ajax.response);
            resolve(jsonData);
          } else {
            reject(message.login_server_error);
          }
        }
      };
    });
  }

  protected createRoot() {
    const rootDom = document.createElement('div');
    // 覆盖input自动填充输入框的背景色
    document.styleSheets[0].addRule(
      'input:-webkit-autofill',
      '-webkit-box-shadow: 0 0 0 1000px #f5f5f5 inset !important;',
    );

    // 手机号输入框
    const phoneDiv = document.createElement('div');
    phoneDiv.style.cssText = 'display: flex; flex: 1; position: relative;';
    const phoneInput = document.createElement('input');
    phoneInput.setAttribute('id', 'phoneNumber');
    phoneInput.setAttribute('placeholder', '请输入手机号');
    phoneInput.style.cssText =
      'width: 100%; height: 42px; border: none; outline:none; background-color: #f5f5f5 ; padding: 0 10px; border-radius: 3px;';
    // 创建手机输入框提示框
    const phoneTipsBox = this.createTips({
      containerId: 'phoneInputContainer',
      contentId: 'phoneInputTipContent',
      text: '',
      top: -30,
      left: 10,
    });
    this.phoneInputEle = phoneInput;

    phoneDiv.appendChild(phoneTipsBox);
    phoneDiv.appendChild(phoneInput);
    rootDom.appendChild(phoneDiv);

    // 验证码输入框
    const codeDiv = document.createElement('div');
    codeDiv.style.cssText =
      'display: flex; flex: 1; position: relative; margin-top: 15px';
    const phoneCode = document.createElement('input');
    phoneCode.setAttribute('id', 'codeNumber');
    phoneCode.setAttribute('placeholder', '请输入验证码');
    phoneCode.style.cssText =
      'width: 100%; height: 42px; border: none; outline:none; background-color: #f5f5f5; padding: 0 10px; border-radius: 3px 0 0 3px;';
    // 创建验证码输入框提示框
    const codeTipsBox = this.createTips({
      containerId: 'codeInputContainer',
      contentId: 'codeInputTipContent',
      text: '',
      top: -25,
      left: 10,
    });

    this.codeInputEle = phoneCode;

    // 验证码按钮
    const getCodeBtn = document.createElement('button');
    getCodeBtn.innerHTML = '获取验证码';
    getCodeBtn.setAttribute('id', 'getCodeBtnId');
    getCodeBtn.style.cssText =
      'min-width: 120px; height: 42px; border: none; text-align: right; background-color: #f5f5f5; color: #09a17b; padding: 0 10px; border-radius: 0 3px 3px 0; cursor:pointer;';
    getCodeBtn.onclick = () => {
      this.getVerifyCode(phoneInput.value);
    };
    codeDiv.appendChild(codeTipsBox);
    codeDiv.appendChild(phoneCode);
    codeDiv.appendChild(getCodeBtn);
    rootDom.appendChild(codeDiv);

    // 登录按钮
    const loginDiv = document.createElement('div');
    loginDiv.style.cssText = 'display: flex; flex: 1';
    const loginBtn = document.createElement('button');
    loginBtn.innerHTML = '登录';
    loginBtn.style.cssText =
      'width: 100%; height: 45px; border: none; font-size: 16px; background-color: #09a17b; color: #fff; padding: 0 10px; margin-top: 28px; border-radius: 3px; cursor:pointer;';
    loginBtn.onclick = () => {
      this.loginClick(loginBtn);
    };
    loginDiv.appendChild(loginBtn);
    rootDom.appendChild(loginDiv);

    return rootDom;
  }

  // 创建提示框
  protected createTips(props: TipsProps) {
    const tipsDiv = document.createElement('div');
    const contentDiv = document.createElement('div');
    const triangleDiv = document.createElement('div');
    tipsDiv.setAttribute('id', props.containerId);
    contentDiv.setAttribute('id', props.contentId);
    tipsDiv.style.cssText =
      'position: absolute; border-radius: 3px; background-color: #fff; color: red; padding: 5px 10px; box-shadow: 0 5px 10px #d4d4d4;';
    triangleDiv.style.cssText =
      'width: 0; height: 0; position: absolute; bottom: -10px; left: 30px; border-top: 5px solid #fff; border-right: 5px solid #fff; border-left: 5px solid rgba(0,0,0,0); border-bottom: 5px solid rgba(0,0,0,0);';
    tipsDiv.style.top = props.top ? props.top + 'px' : '0px';
    tipsDiv.style.left = props.left ? props.left + 'px' : '0px';
    //  默认隐藏提示框
    tipsDiv.style.visibility = 'hidden';
    contentDiv.innerHTML = props.text;

    tipsDiv.appendChild(contentDiv);
    tipsDiv.appendChild(triangleDiv);
    return tipsDiv;
  }

  // 控制提示框的显示
  protected showTips(props: TipsProps) {
    const { containerId, contentId, text } = props;
    const container = document.getElementById(containerId) as HTMLElement;
    const content = document.getElementById(contentId) as HTMLElement;
    if (container.style.visibility === 'visible') return;
    container.style.visibility = 'visible';
    content.innerHTML = text;
    const timer = setTimeout(() => {
      container.style.visibility = 'hidden';
      clearTimeout(timer);
    }, 2000);
  }

  // 获取验证码
  public async getVerifyCode(phoneNumber) {
    // 校验是否输入手机号
    if (this.renderDom) {
      if (!phoneNumber || !phoneNumber.trim()) {
        this.showTips({
          containerId: 'phoneInputContainer',
          contentId: 'phoneInputTipContent',
          text: '必须填写',
        });
        return;
      }
      if (!this.isPhoneNumber(phoneNumber)) {
        this.showTips({
          containerId: 'phoneInputContainer',
          contentId: 'phoneInputTipContent',
          text: '请输入正确的手机号',
        });
        return;
      }
      // 验证码获取计时
      const getCodeBtn = document.getElementById(
        'getCodeBtnId',
      ) as HTMLButtonElement;
      getCodeBtn.disabled = true;
      getCodeBtn.style.cursor = 'not-allowed';
      getCodeBtn.innerHTML = '60秒后重新发送';
    }
    // 发送请求获取验证码
    const sendCodeRes: any = await this.sendCode(phoneNumber);
    if (sendCodeRes.success) {
      const timer = setInterval(() => {
        --this.time;
        if (this.renderDom) {
          const getCodeBtn = document.getElementById(
            'getCodeBtnId',
          ) as HTMLButtonElement;
          getCodeBtn.innerHTML = this.time + '秒后重新发送';
          if (this.time === 0) {
            getCodeBtn.disabled = false;
            getCodeBtn.innerHTML = '获取验证码';
            getCodeBtn.style.cursor = 'pointer';
          }
        }
        if (this.time === 0) {
          clearInterval(timer);
          this.time = 60;
          return;
        }
      }, 999);
    }
    return sendCodeRes;
  }

  protected loginClick(loginBtn: HTMLButtonElement) {
    if (loginBtn.disabled === true) {
      return;
    }
    loginBtn.disabled = true;
    const timer = setTimeout(() => {
      loginBtn.disabled = false;
      clearTimeout(timer);
    }, 2000);

    // 数据校验
    const phoneNumber = document.getElementById(
      'phoneNumber',
    ) as HTMLInputElement;
    const codeNumber = document.getElementById(
      'codeNumber',
    ) as HTMLInputElement;

    const hasError = this.verifyInput(phoneNumber.value, codeNumber.value);
    if (hasError) return;

    this.loginByPhone(phoneNumber.value, codeNumber.value);
  }

  // 校验输入框合法性
  protected verifyInput(phoneNumber, codeNumber) {
    let hasError = false;
    if (!phoneNumber || !phoneNumber.trim()) {
      this.showTips({
        containerId: 'phoneInputContainer',
        contentId: 'phoneInputTipContent',
        text: '必须填写',
      });
      hasError = true;
    }
    if (!codeNumber || !codeNumber.trim()) {
      this.showTips({
        containerId: 'codeInputContainer',
        contentId: 'codeInputTipContent',
        text: '必须填写',
      });
      hasError = true;
    }
    if (!this.isPhoneNumber(phoneNumber)) {
      this.showTips({
        containerId: 'phoneInputContainer',
        contentId: 'phoneInputTipContent',
        text: '请输入正确的手机号',
      });
      hasError = true;
    }
    return hasError;
  }

  // 是否手机号
  protected isPhoneNumber(phoneNumber) {
    return /^1(3\d|4\d|5\d|6\d|7\d|8\d|9\d)\d{8}$/g.test(phoneNumber);
  }

  // 发送验证码
  public async sendCode(phoneNumber) {
    return new Promise(async (resolve, reject) => {
      const url = `${this.host}/api-gateway/sso/api/public/common/login/login_code_send.htm`;
      const data = `mobile=${phoneNumber}&type=1`;
      const res = await this.createHttpRequest(url, 'post', data);
      if (res.data.success) {
        resolve(res.data);
      } else {
        reject(res.data);
      }
    });
  }

  // 获取ticket
  public async loginByPhone(phoneNumber, codeNumber) {
    return new Promise(async (resolve, reject) => {
      // 发送请求获取获取ticket
      const url = `${this.host}/api-gateway/sso/api/public/common/login/login_by_phone.htm`;
      const data = `mobile=${phoneNumber}&code=${codeNumber}&appKey=${this.appkey}`;
      const res = await this.createHttpRequest(url, 'post', data);
      if (res.data.success) {
        if (!res.data.ticket) {
          res.data.ticket = res.data.result;
        }
        this.props.onCallback ? this.props.onCallback(res.data) : '';
        resolve(res.data);
      } else {
        this.props.onError ? this.props.onError(res.data) : '';
        reject(res.data);
      }
    });
  }

  public destroy() {
    this.destroyElement();
  }

  public destroyElement() {
    const element = document.getElementById(this.props.elementId as string);
    if (element && element?.firstChild) {
      element.removeChild?.(element?.firstChild);
    }
  }
}
